import { gql } from "@apollo/client";

export const DROPDOWN_LIST_PGA_FORM = gql`
  fragment dropdownListPGAForm on SelectedListDto {
    id
    name
    minYear
    maxYear
  }
`;
